import React from 'react';
import payments_bg_layer1 from '../../assets/payments_bg_layer1.svg';
import payments_bg_layer2 from '../../assets/payments_bg_layer2.svg';
import payments_bg_layer3 from '../../assets/payments_bg_layer3.svg';

import './paymentsCard.css';

export default function PaymentsCard({ title, icon, description, total, img, children }) {

  let backgroundImage;
  if (img === 'payments_bg_layer1') {
    backgroundImage = payments_bg_layer1;
  } else if (img === 'payments_bg_layer2') {
    backgroundImage = payments_bg_layer2;
  } else if (img === 'payments_bg_layer3') {
    backgroundImage = payments_bg_layer3
  }

  return (
    <div className="payment-card my-4 pt-3">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-10">
            <h5 className="mb-0 ml-2 text-left">
              {title}
            </h5>
          </div>
          <div className="col-2">
            <span className="bg-jungle-green circle-icon sm">
              <i className={`icon icon-${icon} icon-lg text-light-blue`}></i>
            </span>
          </div>
        </div>
        <hr />
        <div>
          {children}
        </div>
      </div>
      <div className="payments-card-bottom py-1" style={{backgroundImage: `url(${backgroundImage})`}}>
        <div className="row align-items-center no-gutters">
          <div className="col-8 text-left">
            <p className="ml-4">
              {description}:
            </p>
          </div>
          <div className="col-4">
            <h4 className="mr-3 text-right">
              £{total}
            </h4>
          </div>
        </div>
      </div>
    </div>
  )
}
